<template>
  <div class="productIcon tooltip">
    <img :src="'/' + product.product_image" class="img-fluid productIcon__image" :alt="product.product_name">
    <span class="tooltip__content">{{ product.product_name }}</span>
    <p class="productIcon__quantity">{{ product.qty }}</p>
  </div>
</template>

<script>
export default {
  props: ['product'],
}
</script>
